export default __webpack_public_path__ + "static/howto-recruiters2-d833a9555c9cc220285a10f573d0473f.svg";